import { Transforms } from "slate";
export var insertIframe = function (editor, url) {
    var urlAfterCom = url.split(".com/")[1].split("/");
    var postName = urlAfterCom.reduce(function (prev, cur, curIdx) {
        if (curIdx > 1) {
            return prev;
        }
        return prev + "/" + cur;
    });
    var text = { text: "" };
    var embed = { type: "embed", url: postName, children: [text] };
    Transforms.insertNodes(editor, embed);
};
